import styled from 'styled-components';
import { BREAKPOINTS } from "../../../app/appConstants";

export const PasswordTooltipContainerStyled = styled.div`
    padding: 8px;
    border-radius: 4px;
    background-color: var(--color-surface-secondary);
    color: var(--text-color-secondary);
    @media(min-width: ${BREAKPOINTS.small}px) {
        width: 300px;
    }
`;

export const PasswordTooltipRequirementStyled = styled.div`
    display: flex;
    align-items: center;
`;

export const PopoverArrowStyled = styled.div`
    &:after {
        border-top-color: var(--color-surface-secondary) !important;
        border-bottom-color: var(--color-surface-secondary) !important;
    }
`;
